import { useState } from "react";

export const RecentActivity = ({ history }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calcul des indices pour pagination
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = history.slice(firstIndex, lastIndex);

  const totalPages = Math.ceil(history.length / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="bg-gray-800 p-4 sm:p-6 rounded-lg border border-gray-700 shadow-sm text-white">
      <h2 className="text-base sm:text-lg font-semibold mb-4">Personal activity</h2>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-gray-700 rounded overflow-hidden text-left min-w-[400px]">
          <thead className="bg-gray-700 text-white">
            <tr>
              <th className="py-3 px-4 border-b border-gray-700">Date</th>
              <th className="py-3 px-4 border-b border-gray-700">Description</th>
            </tr>
          </thead>
          <tbody className="text-white/90">
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="2" className="py-4 px-4 text-center text-gray-400">
                  No recent activity
                </td>
              </tr>
            ) : (
              currentItems.map((entry, index) => {
                const date = new Date(entry.createdAt);
                const formattedTime = date.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
                const formattedDate = date.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                });
                return (
                  <tr key={firstIndex + index} className="border-b border-gray-700 last:border-b-0">
                    <td className="py-2 px-4 whitespace-nowrap">
                      [{formattedTime} - {formattedDate}]
                    </td>
                    <td className="py-2 px-4">{entry.description}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination controls */}
      {history.length > itemsPerPage && (
        <div className="flex justify-end space-x-2 mt-4">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded ${
              currentPage === 1
                ? "bg-gray-600 cursor-not-allowed"
                : "bg-primary hover:bg-primary-dark text-white"
            }`}
          >
            Previous
          </button>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 rounded ${
              currentPage === totalPages
                ? "bg-gray-600 cursor-not-allowed"
                : "bg-primary hover:bg-primary-dark text-white"
            }`}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};
